import React from 'react'
import {
  BarChart3, ScanLine, Grid3x3, TrendingUp, Filter, Sparkles, BookmarkCheck,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { MARKET_INTEL } from '../data'
import { PREVIEWS } from '@/components/landing/home/architecture/previews'
const ICONS = { BarChart3, ScanLine, Grid3x3, TrendingUp, Filter, Sparkles, BookmarkCheck }
export default function MarketIntel() {
  const Scanner = PREVIEWS.scanner
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-12">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Market Intelligence</Eyebrow>
          <SectionHeading align="center"
            title={<>Find the opportunity <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">before your competition.</span></>}
            subtitle="Scanners, heatmaps, filters and AI narratives — built to surface what matters, not to bury it under toolbars."
          />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-10">
          <div className="lg:col-span-3">
            <FeatureGrid items={MARKET_INTEL} icons={ICONS} cols={2} />
          </div>
          <div className="lg:col-span-2">
            <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-white/[0.03] to-white/[0.01] p-4 backdrop-blur-xl h-full">
              <div className="flex items-center gap-1.5 rounded-md bg-black/40 px-2.5 py-2 border border-white/5 mb-3">
                <div className="h-2 w-2 rounded-full bg-red-500/70" />
                <div className="h-2 w-2 rounded-full bg-amber-500/70" />
                <div className="h-2 w-2 rounded-full bg-emerald-500/70" />
                <div className="ml-3 flex-1 h-5 rounded-md bg-white/[0.04] flex items-center px-2 text-[10px] font-mono text-zinc-500">app.kalkiai.trade/scanner</div>
              </div>
              {Scanner && <Scanner />}
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
